import { render, staticRenderFns } from "./InputNetworkAmount.vue?vue&type=template&id=22090821&scoped=true"
import script from "./InputNetworkAmount.vue?vue&type=script&lang=js"
export * from "./InputNetworkAmount.vue?vue&type=script&lang=js"
import style0 from "./InputNetworkAmount.vue?vue&type=style&index=0&id=22090821&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22090821",
  null
  
)

export default component.exports